import React, { ReactNode } from 'react'
import PropTypes from 'prop-types'
import {
  COMPLETED_USER_ID,
  hasRole,
  Logout,
  redirectToHome,
  ROLE_STATUS_ACTIVE_ID,
  ROLE_STUDENT_ID,
  USER_STATUS_UPDATE_NOT_REQUIRED_TO_LOGIN,
} from 'utils'

interface IPersonData {
  person: {
    personStatusId: number
    roles: Array<{
      id: string
      name: string
      schools: ISchoolRoles[]
    }>
  }
}

interface IWrapperRoutesProps {
  component: React.ElementType
  schoolAccess: boolean
  data: IPersonData
}

interface ISchoolRoles {
  id: string
  roleStatus: {
    name: string
    id: string
  }
  tradeName: string
}

const WrapperRoutes = ({ component: Component, schoolAccess, data }: IWrapperRoutesProps) => {
  const INCOMPLETE_USER_MESSAGE =
    'Não conseguimos acessar o Plurall. Tente iniciar o cadastro novamente ou entre em contato com o suporte.'

  const isValidAccess = ({ person }: IPersonData) =>
    [COMPLETED_USER_ID, USER_STATUS_UPDATE_NOT_REQUIRED_TO_LOGIN].includes(person?.personStatusId)

  const isSchoolMember = ({ person }: IPersonData) => {
    const studentRole = hasRole(person, ROLE_STUDENT_ID)

    if (!studentRole) {
      return true
    }

    const isActiveStudent = studentRole.schools.some(
      (school: ISchoolRoles) => +school.roleStatus.id === ROLE_STATUS_ACTIVE_ID,
    )

    return !isActiveStudent
  }

  if (!isValidAccess(data)) {
    return Logout(INCOMPLETE_USER_MESSAGE)
  }

  if (schoolAccess && !isSchoolMember(data)) {
    redirectToHome()

    return null
  }

  return <Component />
}

export default WrapperRoutes
